<template>
  <a-table
    :size="tableDensity"
    :loading="loading"
    :pagination="pagination"
    @change="handleTableChange"
    rowKey="spiderId"
    :columns="showColumns"
    :data-source="tableData"
  >
    <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>
    <span slot="spiderClassId" slot-scope="text, record">
      {{ spiderClassMap[record.spiderClassId] }}
    </span>

    <span slot="spiderId" slot-scope="text, record">
      <a-tooltip>
        <template slot="title"> {{ record.spiderId }} </template>
        <span>
          {{ record.spiderId }}
        </span>
      </a-tooltip>

      <a-tooltip>
        <template slot="title"> 复制 </template>
        <a
          href="javascript:;"
          v-clipboard:copy="text"
          v-clipboard:success="onCopy"
          v-clipboard:error="onCopyError"
        >
          <a-icon type="copy" />
        </a>
      </a-tooltip>
    </span>

    <span slot="spiderName" slot-scope="text, record">
      <Avatar :url="record.headImage" type="news" />
      <a-tooltip>
        <template slot="title"> {{ record.spiderName }} </template>
        <span>
          {{ record.spiderName }}
        </span>
      </a-tooltip>

      <a-tooltip>
        <template slot="title"> 复制 </template>
        <a
          href="javascript:;"
          v-clipboard:copy="text"
          v-clipboard:success="onCopy"
          v-clipboard:error="onCopyError"
        >
          <a-icon type="copy" />
        </a>
      </a-tooltip>
    </span>

    <span slot="totalNum" slot-scope="text, record">
      <a-spin v-if="record.statsLoading" size="small" />
      <template v-else-if="text !== null && text !== undefined">
        {{ Number(text).toLocaleString() }}
      </template>
      <template v-else>--</template>
    </span>
    <span slot="sevenTotalNum" slot-scope="text, record">
      <a-spin v-if="record.statsLoading" size="small" />
      <template v-else-if="text !== null && text !== undefined">
        {{ Number(text).toLocaleString() }}
      </template>
      <template v-else>--</template>
    </span>
    <span slot="country" slot-scope="text, record">
      {{ countryMap[record.country] }}
    </span>
    <span slot="lang" slot-scope="text, record">
      {{ langMap[record.lang] }}
    </span>

    <span slot="execType" slot-scope="text, record">
      <a-badge v-if="record.execType === 1" color="green" text="运行" />
      <a-badge v-else-if="!record.execType" color="orange" text="待运行" />
      <a-badge v-else-if="record.execType === -1" color="red" text="暂停" />
    </span>

    <span slot="action" slot-scope="text, record">
      <a-popconfirm
        v-if="record.execType === -1 || record.execType === 0"
        title="确定要开始调度吗?"
        @confirm="() => handleExecSpiderById(record)"
      >
        <a-button type="link">调度 </a-button>
      </a-popconfirm>
      <a-popconfirm
        v-else-if="record.execType === 1"
        title="确定要停止调度吗?"
        @confirm="() => handleStopSpiderById(record)"
      >
        <a-button type="link">暂停 </a-button>
      </a-popconfirm>
      <a-divider type="vertical"></a-divider>
      <a-button type="link" @click="handleHandExec(record)">执行 </a-button>

      <a-divider type="vertical"></a-divider>
      <a-button @click="handleEdit(record)" type="link">编辑 </a-button>
      <a-divider type="vertical"></a-divider>
      <a-button @click="handleInfo(record)" type="link">详情 </a-button>
      <a-divider type="vertical"></a-divider>
      <a-popconfirm title="确定要删除吗?" @confirm="onDelete(record)">
        <a-button type="link">删除 </a-button> 
      </a-popconfirm>
    </span>
  </a-table>
</template>

<script>
import Avatar from '../components/Avatar.vue'
import {
  querySpiderListApi,
  querySpiderListStatApi,
  stopSpider,
  deleteSpiderItemApi,
  execSpiderByIdApi,
  execNewsItemApi
} from '@/api/Site/Manage'
import tableSettingToStoreMixin from '@/mixin/tableSettingToStroe'
import { deleteSiteApi } from '@/api/Site/Approval'

export default {
  props: {
    tableDensity: String
  },
  mixins: [tableSettingToStoreMixin()],
  data() {
    return {
      search: {
        spiderName: '',
        spiderId: '',
        country: undefined,
        lang: undefined,
        spiderClassId: '',
        execType: undefined,
        orderKey: '',
        isAsc: false
      },
      pagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        size: 'default'
      },
      spiderClassMap: {},
      countryMap: {},
      langMap: {},
      tableData: [],
      columns: [
        {
          title: '序号',
          width: 60,
          align: 'center',
          show: true,
          slots: { title: 'indexTitle' },
          scopedSlots: { customRender: 'index' }
        },
        {
          title: 'ID',
          dataIndex: 'spiderId',
          show: true,
          ellipsis: true,
          scopedSlots: { customRender: 'spiderId' }
        },
        {
          title: '站点名称',
          dataIndex: 'spiderName',
          sorterFiled: 'spider_name',
          show: true,
          defaultSortOrder: '',
          sorter: true,
          ellipsis: true,
          scopedSlots: { customRender: 'spiderName' }
        },
        {
          title: '采集总数量',
          dataIndex: 'totalNum',
          show: true,
          width: 100,
          scopedSlots: { customRender: 'totalNum' }
        },
        {
          title: '近七天数据量',
          dataIndex: 'sevenTotalNum',
          show: true,
          width: 120,
          scopedSlots: { customRender: 'sevenTotalNum' }
        },
        {
          title: '国家',
          dataIndex: 'country',
          show: true,
          width: 100,
          scopedSlots: { customRender: 'country' },
          ellipsis: true
        },
        {
          title: '语言',
          dataIndex: 'lang',
          show: true,
          width: 110,
          scopedSlots: { customRender: 'lang' }
        },
        {
          title: '类型',
          dataIndex: 'spiderClassId',
          show: true,
          width: 80,
          scopedSlots: { customRender: 'spiderClassId' },
          ellipsis: true
        },
        {
          title: '执行状态',
          dataIndex: 'execType',
          show: true,
          width: 90,
          scopedSlots: { customRender: 'execType' },
          align: 'center'
        },
        {
          title: '操作',
          key: 'action',
          show: true,
          scopedSlots: { customRender: 'action' },
          width: 320,
          align: 'center'
        }
      ],
      loading: false,
      listRequestId: 0,
      visible: false
    }
  },
  computed: {
    showColumns() {
      return this.columns.filter((item) => item.show)
    }
  },

  methods: {
    // 复制成功时的回调函数
    onCopy(e) {
      this.$message.success('已复制')
    },
    // 复制失败时的回调函数
    onCopyError(e) {
      this.$message.error('复制失败')
    },
    copy: function () {
      var _this = this
      var clipboard = new Clipboard('#copy_text')

      clipboard.on('success', (e) => {
        message.success('复制成功')
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', (e) => {
        // 不支持复制
        Message({
          message: '该浏览器不支持自动复制',
          type: 'warning'
        })
        // 释放内存
        clipboard.destroy()
      })
    },

    handleEdit({ spiderId }) {
      this.$router.push({
        name: 'site_create_form',
        query: {
          spiderId,
          type: 'news',
          route: 'site_manage'
        }
      })
    },

    handleInfo({ spiderId }) {
      this.$router.push({
        name: 'site_info',
        query: {
          spiderId,
          type: 'news'
        }
      })
    },
    handleTableChange(pagination, filters, { order, column }) {
      this.search.orderKey = column ? column.sorterFiled : ''
      this.search.isAsc = order === 'ascend'
      this.pagination = pagination
      this.querySpiderList()
    },

    async handleSearch(condition) {
      this.pagination.current = 1
      this.search = { ...this.search, ...condition }
      await this.querySpiderList()
    },

    async querySpiderList() {
      const requestId = ++this.listRequestId
      let query = {
        pn: this.pagination.current,
        pageSize: this.pagination.pageSize,
        includeStats: false,
        ...this.search
      }

      this.loading = true
      try {
        let res = await querySpiderListApi(query)
        if (requestId !== this.listRequestId) return

        let { code, msg, data, extra } = res
        if (code == '200') {
          this.tableData = data.map((item) => ({
            ...item,
            totalNum: null,
            sevenTotalNum: null,
            statsLoading: true
          }))
          this.spiderClassMap = extra.spiderClassMap
          this.countryMap = extra.countryMap
          this.langMap = extra.langMap
          this.pagination.total = extra.page.pageCount || 0
          this.querySpiderListStat(this.tableData, requestId)
        } else {
          this.$message.error(msg)
        }
      } catch (error) {
        if (requestId === this.listRequestId) {
          this.$message.error('站点列表加载失败，请稍后重试')
        }
      } finally {
        if (requestId === this.listRequestId) {
          this.loading = false
        }
      }
    },

    async querySpiderListStat(rows, requestId) {
      const spiderIds = rows.map((item) => item.spiderId).filter(Boolean)
      if (!spiderIds.length) return

      try {
        const { code, data } = await querySpiderListStatApi({
          spiderIds: spiderIds.join(',')
        })
        if (requestId !== this.listRequestId) return

        if (code == '200') {
          const statMap = data.reduce((result, item) => {
            result[item.spiderId] = item
            return result
          }, {})
          this.tableData = this.tableData.map((item) => {
            const stat = statMap[item.spiderId]
            return {
              ...item,
              totalNum: stat ? stat.totalNum : 0,
              sevenTotalNum: stat ? stat.sevenTotalNum : 0,
              statsLoading: false
            }
          })
        } else {
          this.finishSpiderStatLoading()
        }
      } catch (error) {
        if (requestId === this.listRequestId) {
          this.finishSpiderStatLoading()
        }
      }
    },

    finishSpiderStatLoading() {
      this.tableData = this.tableData.map((item) => ({
        ...item,
        statsLoading: false
      }))
    },

    async handleDelete({ spiderId }) {
      let res = await deleteSpiderItemApi({
        spiderId
      })
      let { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
        this.querySpiderList()
      } else {
        this.$message.error(msg)
      }
    },

    async handleStopSpiderById({ spiderId }) {
      let res = await stopSpider({
        spiderId
      })
      let { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
        this.querySpiderList()
      } else {
        this.$message.error(msg)
      }
    },

    async handleExecSpiderById({ spiderId }) {
      let res = await execSpiderByIdApi({
        spiderId
      })
      let { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
        this.querySpiderList()
      } else {
        this.$message.error(msg)
      }
    },

    async handleHandExec(record) {
      // 弹框询问是否全量调度（全量调度不过滤系统中已存在的数据）
      const confirm = this.$confirm({
        content: '是否进行单次全量调度（全量调度不过滤系统中已存在的数据）',
        okText: '非全量调度',
        cancelText: '全量调度',
        maskClosable: true,
        onOk: () => {
          this._handleHandExec(record, false)
        },
        onCancel: (e) => {
          if (typeof e === 'object' && e.triggerCancel) {
            confirm.destroy()
          } else {
            this._handleHandExec(record, true)
            return Promise.resolve()
          }
        }
      })
    },

    async _handleHandExec({ spiderId, spiderLevel }, isAll) {
      let res = await execNewsItemApi({
        spiderId,
        spiderLevel,
        isAll
      })
      let { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
      } else {
        this.$message.error(msg)
      }
    },
    async onDelete(record) {
      var param = {}
      param['spiderId'] = record['spiderId']
      param['spiderClassId'] = record['spiderClassId']
      const { code, msg } = await deleteSiteApi(param)
      if (code !== 200) {
        this.$message.error(msg)
        return
      }

      this.$message.success('操作成功')
      this.querySpiderList()
    }
  },
  components: {
    Avatar
  }
}
</script>

<style lang="less" scoped></style>
